var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { EventTypes } from '../events';
export default function Middleware(f) {
  return {
    fold: function fold(evt, store) {
      try {
        return evt ? f(evt, store) : evt;
      } catch (error) {
        return _extends({}, evt, {
          type: EventTypes.NAVIGATION_ERROR,
          error: error
        });
      }
    },
    concat: function concat(other) {
      return Middleware(function (evt, store) {
        if (typeof other.fold === 'function') {
          return other.fold(f(evt, store), store);
        }

        return evt;
      });
    }
  };
}
Middleware.EMPTY = Middleware(function (x) {
  return x;
});